import { render, staticRenderFns } from "./AttractionDataFormComponent.vue?vue&type=template&id=36516ffa&xmlns=true&"
import script from "./AttractionDataFormComponent.vue?vue&type=script&lang=js&"
export * from "./AttractionDataFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./AttractionDataFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36516ffa')) {
      api.createRecord('36516ffa', component.options)
    } else {
      api.reload('36516ffa', component.options)
    }
    module.hot.accept("./AttractionDataFormComponent.vue?vue&type=template&id=36516ffa&xmlns=true&", function () {
      api.rerender('36516ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-multi-attraction/basic-data/forms/attraction-data-form/AttractionDataFormComponent.vue"
export default component.exports